<template>
  <div :class="$style.course">
    <h2 id="js-college-course-title" :class="$style.title">
      <span class="app-fadeInUp">学院课程</span>
    </h2>
    <div id="js-college-course-content" :class="$style.content">
      <div class="app-fadeInUp">
        <div :class="$style.list">
          <the-college-course-item v-for="i in 3" :key="i" :index="i" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fadeMixins from '@/assets/js/fadeMixins'
import TheCollegeCourseItem from './TheCollegeCourseItem'

export default {
  components: { TheCollegeCourseItem },
  mixins: [fadeMixins],
  data() {
    return {
      name: 'college-course',
      animateScenesData: ['title', 'content'],
    }
  },
}
</script>

<style lang="less" module>
.course {
  height: 6.79rem;
  padding-top: 0.87rem;
  background: url('./images/college-course-bg.jpg') no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
}

.title {
  span {
    .subtitle-size(2.92rem, 0.61rem);
    .text-hide();
    display: block;
    margin: 0 auto;
    background: url('./images/college-course-title.png') no-repeat;
    background-size: 100% 100%;
  }
}

.content {
  margin-top: 0.65rem;
}

.list {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: @mini-width) {
  .course {
    height: auto;
    padding-bottom: 0.87rem;
    background-size: auto 100%;
  }
}
</style>
